/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Api_Errors_User_Already_ExistsInputs */

const nl_signup_api_errors_user_already_exists = /** @type {(inputs: Signup_Api_Errors_User_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit e-mailadres is al in gebruik.`)
};

/**

* @param {Signup_Api_Errors_User_Already_ExistsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const signup_api_errors_user_already_exists = /** @type {((inputs?: Signup_Api_Errors_User_Already_ExistsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Api_Errors_User_Already_ExistsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_signup_api_errors_user_already_exists(inputs)
});
export { signup_api_errors_user_already_exists as "signup.api_errors.user_already_exists" }